import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { PATH, ERROR_CODES } from '#/guest-aps/config';
import { ErrorPaymentModule } from '@autopass-web/mochi-payment';
import type { ParsedError } from '../auth-page';

export const ErrorPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const errorCode = searchParams.get('code');
  const paymentError = location.state as ParsedError;

  let errorObj: { title: string; description: string };

  switch (errorCode) {
    case ERROR_CODES.NO_EXIST:
      errorObj = {
        title: '繳費機不存在',
        description: '請聯絡現場管理員並手動出場',
      };
      break;
    case ERROR_CODES.NO_EXIST_RECORD:
      errorObj = {
        title: '找不到停車紀錄',
        description: '請重新掃描並啟用停車線上繳費',
      };
      break;
    case ERROR_CODES.PARKINGLOT_ERROR:
      errorObj = {
        title: '停車場資訊設定錯誤',
        description: '請聯絡現場管理員並手動出場',
      };
      break;
    case ERROR_CODES.PARKINGLOT_SETTING_ERROR:
      errorObj = {
        title: '停車塲連線設定有誤',
        description: '請重新掃描，或聯絡現場管理員並手動出場',
      };
      break;
    case ERROR_CODES.PAYMENT_ERROR:
      errorObj = {
        title: paymentError.title,
        description: '請重新嘗試',
      };
      break;
    case ERROR_CODES.NO_SESSION:
      errorObj = {
        title: '工作階段已過期',
        description: '請重新掃描並啟用停車線上繳費',
      };
      break;
    case ERROR_CODES.APS_DISABLED:
      errorObj = {
        title: '暫停支援',
        description: '本服務暫時停止支援，請以現場其他付款方式繳費離場',
      };
      break;
    default:
      errorObj = {
        title: '未預期錯誤',
        description: '發生未知錯誤，請重新嘗試。',
      };
      break;
  }

  useEffect(() => {
    const handleHistory = () => {
      navigate(`${PATH.ERROR}?${location.search}`);
    };

    window.addEventListener('popstate', handleHistory);
    return () => {
      window.removeEventListener('popstate', handleHistory);
    };
  }, [navigate, location.search]);

  return (
    <ErrorPaymentModule
      title={errorObj.title}
      description={errorObj.description}
    />
  );
};
